export interface GraphQLExtensions {
  requestId: string;
}

// A generic catch-all error. Typically, this captures exceptions that are not recoverable.
export type GenericError = Readonly<{
  name: "Error";
  message: string;
}>;

// This error occurs when the provided Client Token is invalid or expired.
export type InvalidCredentialError = Readonly<{
  name: "InvalidCredentialError";
  context: GraphQLExtensions;
}>;
